const VIEW_TAB = "tab";
const KEY = "weektodo";
const TABS = ["calendar", "lists", "notes", "more", "admin"];

let current = "calendar";
const listeners = new Set();
let listening = false;

function notify() {
  listeners.forEach((fn) => {
    try {
      fn(current);
    } catch (e) {
      console.error(e);
    }
  });
}

function isTab(name) {
  return TABS.includes(name);
}

function parseTabHash(hash) {
  if (!hash || typeof hash !== "string") return null;
  const raw = hash.startsWith("#") ? hash.slice(1) : hash;
  const m = /^\/(calendar|lists|notes|more|admin)$/.exec(raw);
  return m ? m[1] : null;
}

function tabUrl(tab) {
  if (typeof window === "undefined") return "";
  return `${window.location.pathname}${window.location.search}#/${tab}`;
}

function readState(state) {
  if (!state || !state[KEY]) return null;
  const nav = state[KEY];
  if (nav.view !== VIEW_TAB) return null;
  return isTab(nav.tab) ? nav.tab : null;
}

function onPopState(event) {
  let next = readState(event.state);
  if (!next && typeof window !== "undefined") {
    next = parseTabHash(window.location.hash);
  }
  if (next) {
    current = next;
    notify();
  }
}

function ensureListen() {
  if (listening || typeof window === "undefined") return;
  listening = true;
  window.addEventListener("popstate", onPopState);
  const fromState = readState(window.history.state);
  const fromHash = parseTabHash(window.location.hash);
  if (fromState) current = fromState;
  else if (fromHash) current = fromHash;
}

function selectTab(tab, options = {}) {
  ensureListen();
  if (!isTab(tab)) return current;
  if (tab === current && !options.replace) return current;
  const state = { [KEY]: { view: VIEW_TAB, tab } };
  const url = tabUrl(tab);
  if (options.replace) {
    window.history.replaceState(state, "", url || undefined);
  } else {
    window.history.pushState(state, "", url || undefined);
  }
  current = tab;
  notify();
  return current;
}

function getTab() {
  ensureListen();
  return current;
}

function subscribeTab(listener) {
  ensureListen();
  listeners.add(listener);
  listener(current);
  return () => listeners.delete(listener);
}

module.exports = {
  VIEW_TAB,
  TABS,
  parseTabHash,
  selectTab,
  getTab,
  subscribeTab,
};
